
import getClassName from '../../utilities/getClassName'

const PortalKycHeatIndicator = ({kycHeat}) => {

    const classNames = ['portal__kycheat_pill']

    classNames.push(`heat_${kycHeat}`)
    /*
    Hot
    Medium
    Speculative
    Redundant
    Duplicate
    Staff
    */

    return (
        <label className={getClassName(classNames)}>
            {kycHeat}
        </label>
    )

}

export default PortalKycHeatIndicator